<div odxLayout="grid" [formGroupName]="groupName">
  <span odxLayout="10 4@desktop 5@tablet" class="odx-text">{{ label }}</span>
  <odx-switch
    odxLayout="2 1@tablet"
    formControlName="checked"
    [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
  >
  </odx-switch>

  <div odxLayout="12 5@desktop 6@tablet">
    @if (subLabel) {
      <p [class.text-disabled]="disabled">{{ subLabel }}</p>
    }

    <div formArrayName="choices" class="choices-container">
      @for (option of options; track option.value) {
        <odx-checkbox [formControlName]="option.value">{{ option.label }}</odx-checkbox>
      }
    </div>
  </div>
</div>
